import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ImageSwiper from './ImageSwiper'

const ProductImages = ({ images, variantsNum, id }) => {
  const pc = 'in_product-card'

  return (
    <div
      id={`in_product_card_images_${id}`}
      className={cx(`${pc}__images-block`, variantsNum > 1 && `${pc}__images-block--${variantsNum}`)}
    >
      <div className={`${pc}__image-before`} />
      <ImageSwiper images={images} />
      <div className={`${pc}__image-after`} />
    </div>
  )
}

ProductImages.propTypes = {
  variantsNum: PropTypes.number,
  images: PropTypes.array,
  id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
}

export default ProductImages



// WEBPACK FOOTER //
// ./src/templates/insta/components/products/ProductImages.js